// Auto-generated normalizer for table: EstudiantesPremios
export function estudiantesPremiosNormalize(row) {
  return {
    idEstudiantePremios: row.idEstudiantePremios ?? row.IdEstudiantePremios ?? row['IdEstudiantePremios'] ?? 0,
    idEstudiante: row.idEstudiante ?? row.IdEstudiante ?? row['IdEstudiante'] ?? 0,
    idPremio: row.idPremio ?? row.IdPremio ?? row['IdPremio'] ?? 0,
    costo: row.costo ?? row.Costo ?? row['Costo'] ?? 0,
    fechaCompra: row.fechaCompra ?? row.FechaCompra ?? row['FechaCompra'] ?? null,
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
